import { FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { RequestPaginationModel } from '../shared/model/pagination-request-url.model';

export class Util {

    static indexOfSemAcentos(variavel1: string, variavel2: string) {
        if (!variavel1 || !variavel2) {
            return false;
        }

        variavel1 = this.removerAcentos(variavel1.toLowerCase());
        variavel2 = this.removerAcentos(variavel2.toLowerCase());
        return variavel1.indexOf(variavel2) > -1;
    }

    static removerAcentos(value: string) {
        value = value.replace(/[âáã]/g, 'a');
        value = value.replace(/[êé]/g, 'e');
        value = value.replace(/[îí]/g, 'i');
        value = value.replace(/[ôóõ]/g, 'o');
        value = value.replace(/ú/g, 'u');
        value = value.replace(/ç/g, 'c');

        return value;
    }

    static campoPreenchido(campo: string | number | Array<any>): boolean {

        if (campo === undefined || campo == null) {
            return false;
        }

        if (typeof campo === 'string') {
            return campo.trim().length > 0;
        }
        if (campo instanceof Array) {
            return campo.length > 0;
        }

        return true;
    }

    static stringToNumber(valor: string | number): number {

        if (typeof valor === 'number') {
            valor = valor.toString();
        }

        valor = valor.replace('.', '');
        valor = valor.replace(',', '.');

        return Number.parseFloat(valor);
    }

    static getCharactersUnicodeValue(texto: string | number): number {

        if (typeof texto === 'number') {
            texto = texto.toString();
        }

        let valor = 0;
        for (let index = 0; index < texto.length; index++) {
            valor = valor + texto.charCodeAt(index);
        }

        return valor;
    }

    static getValidValues(form: FormGroup): any {
        const retorno = {};
        Object.keys(form.controls).forEach(key => {
            retorno[key] = form.get(key).valid ? form.get(key).value : null;
        });

        return retorno;
    }

    static untouchAllControls(form: FormGroup) {
        Object.keys(form.controls).forEach(control => {
            form.controls[control].markAsPristine();
            form.controls[control].markAsUntouched();
        });
    }

    static touchAllControls(form: FormGroup) {
        Object.keys(form.controls).forEach(control => {
            form.controls[control].markAsTouched();
            form.controls[control].updateValueAndValidity();
        });
    }

    static touchAllControlsNotUpdated(form: FormGroup) {
        Object.keys(form.controls).forEach(control => {
            form.controls[control].markAsTouched();
        });
    }

    static clearAllControlsAndForm(form: FormGroup) {
        Object.keys(form.controls).forEach(control => {
            form.controls[control].setValue(null);
            form.controls[control].markAsPristine();
            form.controls[control].markAsUntouched();
            form.controls[control].updateValueAndValidity();
        });
        form.updateValueAndValidity();
    }

    static isPrivateWindow() {
        return new Promise((resolve) => {
            const localWindow: any = window;
            try {
                const isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
                    navigator.userAgent &&
                    navigator.userAgent.indexOf('CriOS') === -1 &&
                    navigator.userAgent.indexOf('FxiOS') === -1;

                if (isSafari) {
                    // Safari
                    let e = false;
                    if (localWindow.safariIncognito) {
                        e = true;
                    } else {
                        try {
                            localWindow.openDatabase(null, null, null, null);
                            localWindow.localStorage.setItem('test', 1);
                            resolve(false);
                        } catch (t) {
                            e = true;
                            resolve(true);
                        }
                    }
                } else if (navigator.userAgent.includes('Firefox')) {
                    // Firefox
                    const db = indexedDB.open('test');
                    db.onerror = () => {
                        resolve(true);
                    };
                    db.onsuccess = () => {
                        resolve(false);
                    };
                } else if (navigator.userAgent.includes('Edge')
                    || navigator.userAgent.includes('Trident')
                    || navigator.userAgent.includes('msie')) {

                    // Edge or IE
                    if (!localWindow.indexedDB && (localWindow.PointerEvent || localWindow.MSPointerEvent)) {
                        resolve(true);
                    }
                    resolve(false);
                } else {
                    // Other
                    const fs = localWindow.RequestFileSystem || localWindow.webkitRequestFileSystem;
                    if (!fs) {
                        resolve(null);
                    } else {
                        fs(localWindow.TEMPORARY, 100, () => {
                            resolve(false);
                        }, () => {
                            resolve(true);
                        });
                    }
                }
            } catch (err) {
                // console.log(err);
                resolve(null);
            }
        });
    }

    /**
     * Retorna só digitos
     */
    public static removerNotDigit(str) {
        return str.replace(/\D/g, '');
    }

    public static isDataInicioMenor(dataInicio, dataFim) {
        dataInicio = moment(dataInicio, 'DD/MM/YYYY').toDate();
        dataFim = moment(dataFim, 'DD/MM/YYYY').toDate();
        if (dataFim.getTime() < dataInicio.getTime()) {
            return false;
        } else {
            return true;
        }
    }

    public static getMascaraCPF(value) {
        value = value.replace(/\D/g, '');
        value = value.replace(/(\d{3})(\d)/, '$1.$2');
        value = value.replace(/(\d{3})(\d)/, '$1.$2');
        value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
        return value;
    }

    public static getMascaraCNPJ(value: string): string {

        if (!value) {
            return '';
        }
        // Remove máscara e caracteres inválidos
        value = value
            .replace(/[^a-zA-Z0-9]/g, '')
            .toUpperCase()
            .substring(0, 14);

        let resultado = '';
        if (value.length > 0) {
            resultado = value.substring(0, 2);
        }
        if (value.length > 2) {
            resultado += '.' + value.substring(2, 5);
        }
        if (value.length > 5) {
            resultado += '.' + value.substring(5, 8);
        }
        if (value.length > 8) {
            resultado += '/' + value.substring(8, 12);
        }
        if (value.length > 12) {
            resultado += '-' + value.substring(12, 14);
        }
        return resultado;
    }

    public static getMascaraTelefone(texto): string {
        if (!texto) {
            return '';
        }
        texto = texto.replace(/\D/g, '');              // Remove tudo o que não é dígito
        texto = texto.replace(/^(\d{2})(\d)/, '($1) $2');  // Coloca parênteses em volta dos dois primeiros dígitos
        if (texto.length === 9) {
            texto = texto.replace(/(\d{5})(\d)/, '$1-$2');     // Coloca hífen entre o quinto e o sexto dígitos
        } else {
            texto = texto.replace(/(\d{4})(\d)/, '$1-$2');     // Coloca hífen entre o quinto e o sexto dígitos
        }
        return texto;
    }

    public static formatarCpfCnpj(texto: string): string {
        if (!texto) {
            return '';
        }
        const onlyNumbers = texto.replace(/[^a-zA-Z0-9]/g, '');
        texto = onlyNumbers.length <= 11
            ? Util.getMascaraCPF(onlyNumbers)
            : Util.getMascaraCNPJ(onlyNumbers);
        return texto;
    }

    public static somenteNumeros(texto: string): string {
        if (!texto) {
            return '';
        }
        return texto.replace(/\D+/g, '').trim();
    }

    public static removeMascaraCpfCnpj(texto: string): string {
        if (!texto) {
            return '';
        }
         return texto
        .replace(/[^a-zA-Z0-9]/g, '')
        .toUpperCase();
    }

    public static limparEspaco(valor) {
        if (valor.detail.value.length === 1) {
            return valor.detail.value.trim();
        }
    }

    public static orderByDescricao(a, b) {
        if (a.descricao.toLowerCase() > b.descricao.toLowerCase()) {
            return 1;
        }
        if (a.descricao.toLowerCase() < b.descricao.toLowerCase()) {
            return -1;
        }
        return 0;
    }

    public static orderByNome(a, b) {
        if (a.nome.toLowerCase() > b.nome.toLowerCase()) {
            return 1;
        }
        if (a.nome.toLowerCase() < b.nome.toLowerCase()) {
            return -1;
        }
        return 0;
    }

    public static getPermissions(user) {
        const permissions = [];
        let permissionScpa = user.permissoes.find((p: any) => {
            return p.permissao === 'Gestão';
        });
        permissionScpa = permissionScpa.permissoes;
        permissionScpa = permissionScpa.find((permission: any) => {
            return permission.permissao === 'Análise';
        });
        permissionScpa.acoes.forEach(item => {
            permissions.push(item.acao);
        });

        return permissions;
    }


    public static sanitizeUrl(url) {
        if (!url) {
            return "about:blank";
        }

        var invalidProtocolRegex = /^(%20|\s)*(javascript|data|vbscript)/im;
        var ctrlCharactersRegex = /[^\x20-\x7EÀ-ž]/gim;
        var urlSchemeRegex = /^([^:]+):/gm;
        var relativeFirstCharacters = [".", "/"];

        function _isRelativeUrlWithoutProtocol(url) {
            return relativeFirstCharacters.indexOf(url[0]) > -1;
        }

        var sanitizedUrl = url.replace(ctrlCharactersRegex, "").trim();
        if (_isRelativeUrlWithoutProtocol(sanitizedUrl)) {
            return sanitizedUrl;
        }

        var urlSchemeParseResults = sanitizedUrl.match(urlSchemeRegex);
        if (!urlSchemeParseResults) {
            return sanitizedUrl;
        }

        var urlScheme = urlSchemeParseResults[0];
        if (invalidProtocolRegex.test(urlScheme)) {
            return "about:blank";
        }

        return sanitizedUrl;
    }

    public static getMascaraCep(value) {
        value = value.replace(/\D/g, '');
        value = value.replace(/^(\d{5})(\d)/, '$1-$2');
        return value;
    }

    public static mountUrlParam(keyParam: string, value?: string | number, prefix: string = '&'): string {
        if (value === null || value === undefined) {
            return '';
        }

        return `${prefix}${keyParam}=${value}`;
    }

    public static mountPaginationsParams(request: RequestPaginationModel): string {
        const pageParam = this.mountUrlParam('pagina', request.page, '?');
        const tamanhoPaginaParam = this.mountUrlParam('tamanho-pagina', request.pageSize);
        const direcaoOrdenacaoParam = this.mountUrlParam('direcao-ordenacao', request.direcaoOrdenacao);
        const campoOrdenacaoParam = this.mountUrlParam('ordenacao', request.campoOrdenacao);
        const conteudoLivreParam = this.mountUrlParam('conteudo-livre', request.conteudoLivre);
        return `${pageParam}${tamanhoPaginaParam}${direcaoOrdenacaoParam}${campoOrdenacaoParam}${conteudoLivreParam}`;
    }

    public static calcularNovaGestao(niveis: any[] = [], esfera?: string) {
        if (esfera && esfera.trim() === 'F') {
            return "Federal";
        }
        if (!niveis || !niveis.length) {
            return '';
        }
        let selected = "";
        for (let level of niveis) {
            if (!selected) {
                if (level.idGestao) {
                    selected = level.idGestao
                } else {
                    selected = level.gestao.codigo;
                }
            }
            if (selected !== (level.idGestao ? level.idGestao : level.gestao.codigo)) {
                selected = 'D';
                break
            }
        }
        const mappes = {
            'D': 'Dupla',
            'M': 'Municipal',
            'E': 'Estadual',
            'F': 'Federal'
        } as any;
        return mappes[selected];
    }
}
